import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { githubReleasesPlugin } from './modules/githubReleases';
import { githubAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { sspPlugin } from './modules/ssp';
import githubActionsPlugin from './modules/githubActions';
import releaseStatusPlugin from './modules/releaseStatus';
import wizPlugin from '@roadiehq/backstage-plugin-wiz/alpha';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          }}
        />
      ),
  },
});

export default createApp({
  features: [
    catalogPlugin,
    githubActionsPlugin,
    releaseStatusPlugin,
    navModule,
    homeModule,
    githubReleasesPlugin,
    sspPlugin,
    wizPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
